import script from "./MigrateV4Modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MigrateV4Modal.vue?vue&type=script&setup=true&lang=ts"

import "./MigrateV4Modal.vue?vue&type=style&index=0&id=54c9d2c3&lang=scss"

export default script